import { useEffect, useRef } from "react";

import { ASSISTANT_NAME } from "../constants";

export function useAssistantFocus(
  visible: boolean,
  walkthroughActive: boolean,
  screen: string
) {
  const panelRef = useRef<HTMLDivElement>(null);
  const launcherRef = useRef<HTMLDivElement>(null);
  const isPreviouslyVisible = useRef(false);

  useEffect(() => {
    if (visible) {
      const composer = panelRef.current?.querySelector<HTMLTextAreaElement>(
        '[name="assistantPrompt"]'
      );
      const closeButton = panelRef.current?.querySelector<HTMLButtonElement>(
        `button[aria-label="Close ${ASSISTANT_NAME} chat"]`
      );
      (walkthroughActive ? closeButton : composer ?? closeButton)?.focus();
    } else if (isPreviouslyVisible.current) {
      launcherRef.current?.querySelector<HTMLButtonElement>("button")?.focus();
    }
    isPreviouslyVisible.current = visible;
  }, [visible, walkthroughActive]);

  useEffect(() => {
    const content = panelRef.current?.querySelector<HTMLElement>(
      "[data-assistant-content]"
    );
    if (content) content.scrollTop = 0;
  }, [screen]);

  return { panelRef, launcherRef };
}
